import { WidgetFrame } from './WidgetFrame'
import { useWidgetData } from './useWidgetData'
import { WIDGET_KEY, type WidgetProps } from './types'

const WIDGET_KEY_SELF = WIDGET_KEY.readiness

/**
 * AC4 — Readiness. No `evidence.api` read port exists for this yet (§1.5.1
 * of the design note) — the backend returns `coming_soon` for this widget
 * key, and this tile renders that honestly rather than fabricating a `0%`
 * gauge. Real data arrives with the fast-follow (IB-146); `charts/GaugeTile`
 * is already built and ready for it.
 */
export function ReadinessComingSoonWidget({ filter, skipRefetch }: Pick<WidgetProps, 'filter' | 'skipRefetch'>) {
  const { status, message, retry } = useWidgetData<never>(WIDGET_KEY_SELF, filter, skipRefetch)

  return (
    <WidgetFrame
      title="Readiness"
      icon="check-circle"
      state={status === 'ok' ? 'coming_soon' : status}
      message={message ?? 'Ships with the readiness fast-follow (IB-146).'}
      onRetry={retry}
    />
  )
}
